module.exports = __webpack_public_path__ + "static/media/3.48edb84c.jpeg";